import React, {useMemo} from 'react';
import {IOrderProductModel} from '@src/@interfaces/models/Order/IOrderProductModel';

export function OrderTotalProductsPrice(props: {
    modelOptions?: Record<string, any>,
    products: IOrderProductModel[] | undefined,
    children: (totalPrice: number) => React.ReactNode,
}) {
    const totalPrice = useMemo(() => {
        return Math.ceil((props.products ?? []).reduce<number>((res, item) => {
            if (item.has_to_be_ignored_by_order_price === true) {
                return res;
            }

            if (item.is_price_frozen && item.saved_price != null) {
                return res + +item.saved_price;
            }

            if (item.custom_price != null) {
                const price = item.custom_price_type === 'for-unit' ?
                        item.custom_price * item.quantity :
                        item.custom_price;

                return res + (+price * 100);// 'cause that field contains dollars, but others - cents
            }

            if (item.product_id) {
                const price = props.modelOptions?.products?.find(
                        ({value}: { value: number }) => value === item.product_id
                )?.price ?? 0;
                const quantity = item.quantity ?? 1;

                return res + (price * quantity);
            }

            return res;
        }, 0) / 100);
    }, [props.modelOptions?.products, props.products]);

    return <>{props.children(totalPrice)}</>;
}
